module.exports = __webpack_public_path__ + "assets/wedodesign.8de26f3555ce4d48a545b1f5d0cd5781.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/wedodesign.png
 ** module id = 377
 ** module chunks = 0
 **/